import Introduction from "../../componets/Introduction";

export default function Section2() {
  return (
    <div className="Section2">
      <Introduction
        title="Introduction"
        text="Mean3 Staff augmentation services enable business owners and organizations to ensure a project's success by employing the best personnel in the sector for a small fraction of the expense of recruiting an in-house technical team.To offer our clients the best technical and subject matter expertise, our Staff Augmentation employs a strict internal recruitment procedure. To help our clients achieve real business benefits, we train our recruitment staff on the best practices for identifying and hiring the best people on the market."
        divider={true}
      />
    </div>
  );
}
